import '../Scss/style.scss';
import { defineAsyncComponent } from 'vue';
import { Component } from '@vue/runtime-core';
import createApp, { VueDsCookies } from '@digitalwerk/frontend-muster';
import gsap from 'gsap';
import SplitType from 'split-type';

// const NewsList = defineAsyncComponent(() => import('./Components/NewsList.vue'));
// const Search = defineAsyncComponent(() => import('./Components/Search.vue'));

const PageHeader = defineAsyncComponent(() => import('./Components/PageHeader.vue'));
const Media = defineAsyncComponent(() => import('./Components/Media.vue'));
const WaveImage = defineAsyncComponent(() => import('./Components/WaveImage.vue'));
const ImageRail = defineAsyncComponent(() => import('./Components/ImageRail.vue'));
const Team = defineAsyncComponent(() => import('./Components/Team.vue'));
const Timeline = defineAsyncComponent(() => import('./Components/Timeline.vue'));
const TwentySummers = defineAsyncComponent(() => import('./Components/TwentySummers.vue'));
const ContactMap = defineAsyncComponent(() => import('./Components/ContactMap.vue'));

// // import * as Sentry from "@sentry/vue";
//
// //TODO: Vue Sentry, DNS must be https
// // Sentry.init({
// //     Vue: Vue,
// //     dsn: "http://4d7eadae930d4b6eae70a46050ff6f4e@195.2.221.3:9000/5",
// // });
// // Vue.config.errorHandler = function (err, vm, info) {
// //     Sentry.captureMessage(err.toString())
// // }
// // Vue.config.warnHandler = function (msg, vm, trace) {
// //     Sentry.captureMessage(msg.toString())
// // }

const FIRST_LOAD_ANIMATION_DELAY = 2;
const MQL_MOBILE = window.matchMedia('(max-width: 991.99px)');

const projectRootComponent:Component = {
  provide() {
    return {
      mqlMobile: MQL_MOBILE,
      lazyLoad: this.lazyLoad,
      scrollOffset: this.scrollOffset,
    };
  },
  components: {
    'page-header': PageHeader,
    media: Media,
    'wave-image': WaveImage,
    'image-rail': ImageRail,
    team: Team,
    timeline: Timeline,
    'twenty-summers': TwentySummers,
    'contact-map': ContactMap,
  },
  methods: {
    mountedHook() {
      this.pageLoaderLoaded();
      this.handleFirstLoadAnimation();
    },
    pageLoaderLoaded() {
      document.body.classList.remove('loaded');
      // reflow
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const reflow = document.body.offsetHeight;
      document.body.classList.add('loaded');
    },
    handleFirstLoadAnimation() {
      if (sessionStorage.getItem('dw-firstload')) {
        return;
      }
      if (MQL_MOBILE.matches || !document.body.classList.contains('page-id-1')) {
        sessionStorage.setItem('dw-firstload', '1');
        return;
      }
      // first text element
      const textEl = document.querySelector('.content-element:first-child');
      if (textEl) {
        const textElHeadline = textEl.querySelector('h1, .h1, h2, .h2');
        const textParagraphs = textEl.querySelectorAll('p');
        const header = document.querySelector('.header-wrapper');
        const mediaElem = document.querySelector('.content-element:nth-child(2)');

        if (textParagraphs) {
          gsap.set(textParagraphs, { opacity: 0 });
        }
        if (header) {
          gsap.set(header, { opacity: 0 });
        }
        if (mediaElem) {
          gsap.set(mediaElem, { opacity: 0 });
        }

        if (textElHeadline) {
          const text = new SplitType(textElHeadline as HTMLElement, { types: 'lines' });
          gsap.from(text.lines, {
            opacity: 0,
            y: 80,
            duration: 0.8,
            delay: FIRST_LOAD_ANIMATION_DELAY,
            stagger: {
              amount: 1,
            },
            onComplete: () => {
              text.revert();
              this.handleFirstLoadAnimationHeaderMedia(header, mediaElem, textParagraphs);
            },
          });
        } else {
          this.handleFirstLoadAnimationHeaderMedia(header, mediaElem);
        }
      }
      sessionStorage.setItem('dw-firstload', '1');
    },
    handleFirstLoadAnimationHeaderMedia(
      header: HTMLElement, mediaElem: HTMLElement, textParagraphs: HTMLElement | undefined,
    ) {
      if (header) {
        gsap.fromTo(header, {
          y: -80,
        }, {
          opacity: 1,
          y: 0,
          duration: 0.6,
          onComplete: () => {
            header.style.removeProperty('transform');
          },
        });
      }

      if (mediaElem) {
        gsap.fromTo(mediaElem, {
          y: 150,
        }, {
          opacity: 1,
          y: 0,
          duration: 0.6,
        });
      }

      if (textParagraphs) {
        gsap.to(textParagraphs, {
          opacity: 1,
          duration: 0.6,
        });
      }

      const bgDecoration = mediaElem.querySelector('.bg-decoration');
      if (bgDecoration) {
        gsap.fromTo(bgDecoration, {
          backgroundPositionX: -10,
        }, {
          backgroundPositionX: 0,
          duration: 0.6,
        });
      }
    },
  },
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const app = createApp(projectRootComponent);

app.use(VueDsCookies);

app.mount('#page');
